import { render } from "./DashboardProject.vue?vue&type=template&id=1a072b8c"
import script from "./DashboardProject.vue?vue&type=script&lang=js"
export * from "./DashboardProject.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__